// Hardcoded expiry date - this is currently always fixed and not used in the current flow, but required on the endpoint request.
export const FIXED_EXPIRY_DATE = '4925';

// Placeholder expiry date for gift card balance checks - required by the API but not validated
export const EXPIRY_DATE_PLACEHOLDER = '2512';

export const CREDIT_TRANSACTION_TYPES = ['reload', 'refund', 'transfer_in', 'activation'];

// Gift card BIN ranges that require 4-digit PIN
export const GIFT_CARD_PIN_BIN_PREFIXES = [
  '589629304',
  '589629305',
  '58962913',
  '589629429',
  '589629435',
  '589629436',
  '589629437',
  '589629487',
];

// Gift card BIN ranges that require NO security field
const GIFT_CARD_NO_PIN_BIN_PREFIXES = ['589629329', '589629332'];

export type GiftCardSecurityFieldType = 'pin' | 'none';

const couldMatchList = (cardNumber: string, prefixes: string[]): boolean =>
  prefixes.some(
    prefix => cardNumber.startsWith(prefix) || prefix.startsWith(cardNumber),
  );

/**
 * Determines whether a gift card requires a 4-digit PIN based on its BIN prefix.
 * Uses bidirectional prefix matching so the PIN field appears as soon as the typed
 * digits can ONLY resolve to a PIN BIN. If the partial input is ambiguous (could
 * still become a no-pin BIN like 589629329 or 589629332), the field stays hidden
 * until enough digits are entered to disambiguate.
 */
export const getGiftCardSecurityFieldType = (cardNumber: string): GiftCardSecurityFieldType => {
  const cleanCardNumber = cardNumber.replace(/\s/g, '');

  if (!cleanCardNumber) {
    return 'none';
  }

  const couldBePin = couldMatchList(cleanCardNumber, GIFT_CARD_PIN_BIN_PREFIXES);
  const couldBeNoPin = couldMatchList(cleanCardNumber, GIFT_CARD_NO_PIN_BIN_PREFIXES);

  if (couldBePin && !couldBeNoPin) {
    return 'pin';
  }

  return 'none';
};
